import React from "react";
import PropTypes from "prop-types";

const BrokerSection = ({ title, children: fields }) => {
  return (
    <div className="section">
      <h3 className="section-title">{title}</h3>
      {fields}
    </div>
  );
};

BrokerSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.object,
};

export default BrokerSection;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/formSections/BrokerSection.js